import React from 'react';
import { Box } from '@mui/system';

interface IOwnProps {
    errorCode: number;
}

const menuLessErrorTemplate = ({ errorCode }: IOwnProps) => {
    return (
        <Box
            display="flex"
            height="100vh"
            width="100%"
            alignItems="center"
            justifyContent="center"
            border="1px solid black"
        >
            <iframe
                style={{ width: '100%', height: '100%' }}
                src={`/embed/${errorCode}`}
            />
        </Box>
    );
};

export default menuLessErrorTemplate;
